import { render, staticRenderFns } from "./EntryMessageHistoryToApplicant.vue?vue&type=template&id=af686c92"
import script from "./EntryMessageHistoryToApplicant.vue?vue&type=script&lang=js"
export * from "./EntryMessageHistoryToApplicant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports